import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate,Suggest2 } from '@blueprintjs/select';
import { Checkbox, Utils } from "@blueprintjs/core";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useHistory } from "react-router-dom";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";
import "./DividendProcess.scss"

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { WithdrawalInfo, StkCodeInfo, AcCodeInfo } from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}
export interface CurrencyInfo {
    d_Currency: string,
    d_CcyDesc: string,
}
var GsbFlag: any;



interface StkGlobalWithdrawalMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function StkGlobalWithdrawalMain({ gsb}: StkGlobalWithdrawalMainProps) {


        
    //handling Fee 
    const [s_handlefee, sets_handlefee] = useState(utils.numToString(0.00))
    const [CurrencyValue, setCurrencyValue] = useState("")
    const [CurrencyList2, setCurrencyList2] = useState([] as CurrencyInfo[])
    const [CurrencyList, setCurrencyList] = useState([] as CurrencyInfo[])
  
 
    const [DescValue, setDescValue] = useState("")
    const [DescValue2, setDescValue2] = useState("")

    const [ST_DESC2, setST_DESC2] = useState(false)
    const [selectedCurrency, setSelectedCurrency] = useState<CurrencyInfo | null>(null)

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    const history = useHistory()

    const [Data, setData] = useState([] as WithdrawalInfo[])

    const [searchKey, setSearchKey] = useState("StkNo")

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkNo, setsearchStkNo] = useState("")
    const [showButton, setshowButton] = useState(false)
    const [showCalcButton, setshowCalcButton] = useState(true)
    const [ShowWait, setShowWait] = useState(false)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [BlankWithdrawal, setBlankWithdrawal] = useState({} as WithdrawalInfo)
    const [currentWithdrawal, setcurrentWithdrawal] = useState({} as WithdrawalInfo)

    const [s_StkNo1, sets_StkNo1] = useState("")
    const [s_StkNo2, sets_StkNo2] = useState("")
    const [s_KeepAllocationValue, sets_KeepAllocationValue] = useState("Y")
    const [s_SplitConsolidate_Old, sets_SplitConsolidate_Old] = useState("")
    const [s_SplitConsolidate_New, sets_SplitConsolidate_New] = useState("")


    const [currentMode, setcurrentMode] = useState("show")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")
    const [dateFormat, setdateFormat] = useState("")


    BlankWithdrawal.d_acCode = ""
    BlankWithdrawal.d_StkNo1 = ""
    BlankWithdrawal.d_StkNo2 = ""


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("StkGlobalWithdrawalMain disp user_key: ", res.data.Flag.user_key)
                //console.log("StkGlobalWithdrawalMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("StkGlobalWithdrawalMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("StkGlobalWithdrawalMain disp GsbFlag: ", GsbFlag)
                //console.log("StkGlobalWithdrawalMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("StkGlobalWithdrawalMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("StkGlobalWithdrawalMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("StkGlobalWithdrawalMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("StkGlobalWithdrawalMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setdateFormat(GsbFlag.dateFormat);
 
                setST_DESC2(GsbFlag.ST_DESC2)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
{/*
    useEffect(() => {
        (async () => {
            try {
                // get Market List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "ExchangeRate", cAction: "GetCCYList"})

                //console.log("MarketList: ", res.data.data) 
                CurrencyList2.push({d_Currency: "", d_CcyDesc: "HKD"})
                for (let j = 0; j < res.data.data.length; j++) {
                    CurrencyList2.push({d_Currency: res.data.data[j][0], d_CcyDesc: res.data.data[j][1]})
                }
                setCurrencyList(CurrencyList2)
                //console.log("set CurrencyList: ", CurrencyList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

*/}
    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/Master', { sb_data: "", cPgmId: "ExchangeRate", cAction: "GetCCYList" });
                const freshList: CurrencyInfo[] = [];
                freshList.push({ d_Currency: "", d_CcyDesc: "HKD" });
                if (res.data && res.data.data) {
                    for (let j = 0; j < res.data.data.length; j++) {
                        freshList.push({
                            d_Currency: res.data.data[j][0],
                            d_CcyDesc: res.data.data[j][1]
                        });
                    }
                }                
                setCurrencyList2(freshList);
                setCurrencyList(freshList);
                
            } catch (error) {
                utils.showError(error);
            }
        })()
    }, [gsb]); 


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
    }        



    const onChangeNewQty = (acCode: string, NewQty: string) => {
        if (acCode.length > 0 ) {
            //console.log("onChangeNewQty acCode", acCode, DivAmount);

            //let newData = [...Data]

            for (let j = 0; j < Data.length; j++) {
                if ( Data[j].d_acCode == acCode ) {
                    Data[j].d_New_qty = NewQty
                    break
                }
            }
            //setData(newData)
            setshowButton(true)
            setshowCalcButton(true)
        }
    }

    /*
    * update handleFee by acCode ,on ..Data
    */
    const onChangehandleFee = (acCode: string, handleFee: (string)) => {
        if (acCode.length > 0) {        
            for (let j = 0; j < Data.length; j++) {
                if (Data[j].d_acCode == acCode) {
                    Data[j].d_Handling_fee = utils.StringToNum (handleFee);
                    break;
                }
            }
            setshowButton(true);
            setshowCalcButton(true);
        }
    }


    const onWithdrawalProcess = () => {
        setShowWait(true)
        setshowButton(false)
        setshowCalcButton(false)
        ;

        console.log("onWithdrawalProcess Data", Data);
        (async () => {
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: Data, 
                    s_HandlefeeDesc:DescValue,      
                    s_HandlefeeDesc2:DescValue2,                                      
                    cPgmId: "StkDepWithTranEntry",
                    cAction: "WithdrawalProcess",
                })                
                if ( res.data.ok ) {
                    utils.showSuccess(res.data.data)
                } else {
                    utils.showWarn(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        setshowCalcButton(true)
    }

    const onCaclWithdrawal = () => {
        setShowWait(true)
        setshowButton(false)
        setshowCalcButton(false)
        ;

        (async () => {
            setData([])
            ;
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: {
                        s_StkNo1: s_StkNo1,
                        s_StkNo2: s_StkNo2,
                        s_Handling_fee:s_handlefee,   
                        s_Currency :CurrencyValue,
                        s_KeepAllocation: (s_KeepAllocationValue==="Y"),
                        s_SplitConsolidate_Old: s_SplitConsolidate_Old,
                        s_SplitConsolidate_New: s_SplitConsolidate_New,
                    }, 
                    cPgmId: "StkDepWithTranEntry",
                    cAction: "CaclWithdrawal",
                })                
                if ( res.data.ok ) {
                    setData(res.data.data)
                    if (res.data.count > 0) {
                        setcurrentWithdrawal(res.data.data[0])
                    }
                    console.log("onCaclWithdrawal res.data.data", res.data.data);
                    console.log("onCaclWithdrawal Data", Data);

                    //utils.showSuccess(res.data.data)
                } else {
                    utils.showWarn(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })() 
        setShowWait(false)
        setshowButton(true)
        setshowCalcButton(true)
    }
    
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    const CurrencyRenderer: ItemRenderer<CurrencyInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${CurrencyList.d_CcyDesc}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CurrencyList.d_Currency}
                key={CurrencyList.d_Currency}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const CurrencyPredicate: ItemPredicate<CurrencyInfo> = (query, CurrencyList, _index, exactMatch) => {
        const normalizedText = `${CurrencyList.d_Currency} - ${CurrencyList.d_CcyDesc}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const CurrencyValueRenderer = (CurrencyList: CurrencyInfo) => {
        return CurrencyList.d_Currency
    }
    
    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

 
   function showdefDesc() {
        //console.log("showdefDesc :", DescValue, TranTypeValue, StkNoValue, QtyValue)
        if ( DescValue.trim().length == 0 ) {
            if ( s_StkNo1.trim().length > 0 && s_StkNo1.trim().length > 0  && s_SplitConsolidate_Old.trim().length > 0 && s_SplitConsolidate_Old.trim().length > 0) {
                let M_DESC = ""

                M_DESC = "HANDLING FEE TRANSFER ("+s_StkNo1+") TO ("+ s_StkNo2 +")"
                setDescValue(M_DESC)
            }
        }
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>





    let list = <>
        <div className="Row">
            <Button disabled={! showButton} className="Col-1-1" icon="confirm" onClick={() => { onWithdrawalProcess() } }>Process</Button> 
            <Button disabled={! showCalcButton}className="Col-2-2" icon="calculator" onClick={() => { onCaclWithdrawal() } }>Withdrawal Calculate</Button> 
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Account No.</th>
                <th className="TCol-ACName">Name</th>
                <th className="TCol-oh_qty">On Hand Qty</th>
                <th className="TCol-New_Qty">New Stock Qty</th>
                <th className="TCol-New_Qty">Handling Fee</th>
                <th className="TCol-New_Qty">Handling Fee currency</th>                
            </thead>
            <tbody id="ma_tr">
                {Data.map((WithdrawalRec, i) =>
                    <tr key={i} onDoubleClick={() => { } }>
                        <td className="TCol-ACCode" onClick={() => { } }>{WithdrawalRec.d_acCode}</td>
                        <td className="TCol-ACName" onClick={() => { } }>{WithdrawalRec.d_acName1}</td>
                        <td className="TCol-oh_qty" onClick={() => { } }>{WithdrawalRec.d_oh_qty}</td>
                        {(WithdrawalRec.d_show_new_qty === "Y") && 
                            <td className="c" onClick={() => { } }>
                                <InputGroup className="inputNumberNoSpin" 
                                id="inputNew_qty" 
                                defaultValue={WithdrawalRec.d_New_qty}
                                type="number" 
                                onChange={utils.handleStringChange(s => onChangeNewQty(WithdrawalRec.d_acCode, s ))} 
                                />
                            </td>
                        }
                        {(WithdrawalRec.d_show_new_qty === "Y") && (
                           <td className="c" onClick={() => { } }>
                               <InputGroup 
                                   className="inputNumberNoSpin2" 
                                   id={`inputNew_qty2_${WithdrawalRec.d_acCode}`} 
                                   defaultValue={utils.numToString(WithdrawalRec.d_Handling_fee)}  
                                   type="number"   
                                   onBlur={utils.handleNumericBlur((formattedValue) => {
                                       onChangehandleFee(WithdrawalRec.d_acCode, formattedValue);
                                   })}
                                    onChange={utils.handleStringChange(s => onChangehandleFee(WithdrawalRec.d_acCode, s ))} 

        
                               />
                           </td>
                        )}
                        
                        {(WithdrawalRec.d_show_new_qty === "Y") && 
                            <td className="TCol-d_Currency" onClick={() => { } }>{WithdrawalRec.d_Currency}</td>
                            
                        }                        
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <div>
                        <H3>344 Global Withdrawal/ Transfer of a Stock</H3>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup inline className="Col-1-5" label="Stock No. for Global Withdrawal" labelFor="inputStkNo1">
                            <InputGroup
                                id="inputStkNo1"
                                autoFocus={true}
                                placeholder="Stock No ..."
                                value={s_StkNo1}
                                onChange={utils.handleStringChange(s => sets_StkNo1(s))}
                            />
                        </FormGroup>
                        <FormGroup className="Col-6-3">
                            <div id="DispText">{currentWithdrawal.d_StkCode1}</div>
                            <div id="DispText">{currentWithdrawal.d_StkName1}</div>
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup inline className="Col-1-5" label="To Transfer to Stock No." labelFor="inputStkNo1">
                            <InputGroup
                                id="inputStkNo2"
                                placeholder="Trsnaser Stock No ..."
                                value={s_StkNo2}
                                onChange={utils.handleStringChange(s => sets_StkNo2(s))}
                            />
                        </FormGroup>
                        <FormGroup className="Col-6-3">
                            <div id="DispText">{currentWithdrawal.d_StkCode2}</div>
                            <div id="DispText">{currentWithdrawal.d_StkName2}</div>
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup inline className="Col-1-4" label="Keep Stock Allocation Position" >
                            {/* <Switch id="inputs_KeepAllocationValue" label="" innerLabelChecked="Yes" innerLabel="No" checked={s_KeepAllocationValue} onChange={utils.handleBooleanChange(v => sets_KeepAllocationValue(v))} /> */}
                            <RadioGroup
                                name="s_KeepAllocationValue"
                                inline={true}
                                selectedValue={s_KeepAllocationValue}
                                onChange={utils.handleStringChange(s => sets_KeepAllocationValue(s)) }
                            >
                                <Radio label="Yes" value="Y" />
                                <Radio label="No"  value="N" />
                            </RadioGroup>
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup inline className="Col-1-3" label="Split/Consolidate" labelFor="inputSplitConsolidate_Old">
                            <InputGroup className="inputNumberNoSpin" type="number"
                                id="inputSplit_Old"
                                value={s_SplitConsolidate_Old}
                                onChange={utils.handleStringChange(s => sets_SplitConsolidate_Old(s))}
                            />
                        </FormGroup>
                        <FormGroup inline className="Col-4-3" label="into shares" labelFor="inputSplitConsolidate_New">
                            <InputGroup className="inputNumberNoSpin" type="number"
                                id="inputSplit_Old"
                                value={s_SplitConsolidate_New}
                                onChange={utils.handleStringChange(s => sets_SplitConsolidate_New(s))}
                            />
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup inline className="Col-1-4" label="Handling fee Currency" labelFor="inputCurrency" labelInfo="*">
                            <Suggest2
                                inputProps={{ placeholder: "Currency ..." }}
                                query={CurrencyValue}
                                onQueryChange={(queryText) => {
                                    setCurrencyValue(queryText);
                                }}
                                activeItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                                selectedItem={CurrencyList.find((Ccy) => Ccy.d_Currency === CurrencyValue)}
                                items={CurrencyList}
                                itemRenderer={CurrencyRenderer}
                                itemPredicate={CurrencyPredicate}
                                inputValueRenderer={CurrencyValueRenderer}
                                onItemSelect={(item) => {setCurrencyValue(item.d_Currency); 
                                }}
                            />
                        </FormGroup>
                        <FormGroup inline className="Col-1-3" label="Handling fee" labelFor="inputhandlefee">
                        <InputGroup id="inputhandlefee" placeholder="Handling Fee ..." 
                            defaultValue={s_handlefee} value={s_handlefee} 
                            onBlur={utils.handleNumericBlur(n => sets_handlefee(n))} 
                            onChange={utils.handleStringChange2(n => sets_handlefee(n))}
                         />                                  
                        </FormGroup> 
                      
                    </div>

                    <div className="Row">
                        <FormGroup className="Col-1-5" label="Handling Fee description." labelFor="inputHandling_Description" >
                            <InputGroup
                                id="inputHandling_Description1"
                                placeholder="Handling fee descrption 1 ..."
                                fill={true}
                                value={DescValue} 
                                defaultValue=""
                                onFocus={showdefDesc}
                                onChange={utils.handleStringChange(s =>setDescValue(s.toUpperCase()))}
                               
                            /> 
                            <InputGroup
                                id="inputHandling_Description2"
                                 placeholder="Handling fee descrption 2 ..."
                                fill={true}
                                defaultValue={DescValue2}
                                maxLength={60}
                                
                                onChange={utils.handleStringChange(s => setDescValue2(s.toUpperCase()))}

                              
                            />                         
                        </FormGroup>    

                    </div>
              

 
                    <div className="Spacing-V-16" />
                    {list}
                    <div className="Spacing-V-16" />
                </Card>
            </form>
        </>
    );
}

export default StkGlobalWithdrawalMain